/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractDto } from '../../models/backend-leasing-contract-dto';
import { BackendPatchedLeasingContractRequestDto } from '../../models/backend-patched-leasing-contract-request-dto';

export interface FinancingSourcesLeasingsPartialUpdate$Params {
  /**
   * A unique integer value identifying this leasing contract.
   */
  id: number;
  body?: BackendPatchedLeasingContractRequestDto;
}

export function financingSourcesLeasingsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesLeasingsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLeasingContractDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesLeasingsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLeasingContractDto>;
    }),
  );
}

financingSourcesLeasingsPartialUpdate.PATH = '/api/financing_sources/leasings/{id}/';
